/* eslint-disable import/no-extraneous-dependencies */
module.exports = {

  // content: [ // we need lines 5-9 if we'll use Tailwind v3
  //   './public/*.html',
  //   './app/helpers/**/*.rb',
  //   './app/javascript/**/*.js',
  // according https://tailwindcss.com/docs/content-configuration we should never include CSS files in your content configuration
  // ],
  // line 11-16 are needed for Tailwind v2
  mode: 'jit', // we need this line to use arbitrary values (ex p-[12.5px]) https://v2.tailwindcss.com/docs/just-in-time-mode
  purge: [
    './app/javascript/**/*.js',
    './app/helpers/**/*.rb',
  ],
  theme: {
    // Do not use arbitrary values in the theme object: it will rewrite the whole theme object, use extend instead
    // use number to refer to the tailwind units, where
    // one  unit is equal to 0.25rem,
    // which translates to 4px by default in common browsers.
    // in other case use string
    extend: {
      fontFamily: {
        sans: ['DM Sans', 'sans-serif'],
        pally: ['Pally-Bold', 'sans-serif'],
      },
      animation: {
        progress: 'progress 1s infinite linear',
      },
      keyframes: {
        progress: {
          '0%': { transform: ' translateX(0) scaleX(0)' },
          '40%': { transform: 'translateX(0) scaleX(0.7)' },
          '100%': { transform: 'translateX(100%) scaleX(0.8)' },
        },
      },
      transformOrigin: {
        'left-right': '0% 50%',
      },
      // default font sizes: https://tailwindcss.com/docs/font-size
      // in tailwind classes this font size will be called as 'text-40'
      fontSize: {
        24: '24px',
        10: '10px',
        14: '14px',
        32: '32px',
        40: '40px',
      },
      // in tailwind classes this shadow will be called as 'shadow-vamos-drop-shadow'
      boxShadow: {
        'vamos-drop-shadow': '0 8px 8px 0 rgba(204, 204, 204, 0.15)',
        'vamos-shadow': '0px 8px 8px 0px rgba(0, 0, 0, 0.15)',
      },
      // with Tailwind v2
      // By default the spacing scale is inherited by the padding, margin, width, height,
      // maxHeight, gap, inset, space, and translate core plugins.
      // Tailwind v2 spacing scale doesn't inherit min-width, min-height, and max-height
      // according Tailwind default spacing scale: one spacing unit is equal to 0.25rem,
      // which translates to 4px by default in common browsers.
      // rules for Tailwind v2  https://v2.tailwindcss.com/docs/customizing-spacing#default-spacing-scale
      spacing: {
        1.25: '5px',
        1.5: '6px',
        1.75: '7px',
        2.25: '9px',
        2.5: '10px',
        2.75: '11px',
        3.25: '13px',
        3.5: '14px',
        3.75: '15px',
        4.25: '17px',
        4.5: '18px',
        4.75: '19px',
        4.85: '19.5px',
        5.25: '21px',
        5.5: '22px',
        5.75: '23px',
        6.25: '25px',
        6.5: '26px',
        6.75: '27px',
        7.5: '30px',
        7.75: '31px',
        8.25: '33px',
        8.5: '34px',
        8.75: '35px',
        9: '36px',
        9.5: '38px',
        9.75: '39px',
        10.5: '42px',
        10.75: '43px',
        11.25: '45px',
        11.5: '46px',
        12.5: '50px',
        12.75: '51px',
        13: '52px',
        13.5: '54px',
        15: '60px',
        15.75: '63px',
        16.5: '66px',
        17: '68px',
        17.5: '70px',
        18.5: '74px',
        18.25: '73px',
        19.5: '78px',
        20.5: '82px',
        21: '84px',
        21.25: '85px',
        21.5: '86px',
        22: '88px',
        23: '92px',
        23.5: '94px',
        23.75: '95px',
        24.5: '98px',
        25.5: '102px',
        26: '104px',
        27: '108px',
        27.75: '111px',
        29.5: '118px',
        31: '124px',
        31.75: '127px',
        33.25: '133px',
        33.75: '135px',
        34: '136px',
        36.5: '146px',
        41: '164px',
        42.75: '171px',
        43: '172px',
        43.75: '175px',
        45: '180px',
        46.25: '185px',
        47: '188px',
        47.5: '190px',
        50: '200px',
        50.5: '202px',
        50.75: '203px',
        51.75: '207px',
        53.75: '215px',
        56: '224px',
        59.75: '239px',
        65.5: '262px',
        67.75: '271px',
        68.25: '273px',
        71: '284px',
        73.5: '294px',
        69: '276px',
        72.75: '291px',
        74: '296px',
        75: '300px',
        77: '308px',
        77.5: '310px',
        80: '320px',
        83.5: '334px',
        85.75: '343px',
        87.5: '350px',
        88: '356px',
        88.5: '354px',
        92.5: '370px',
        98.25: '393px',
        100: '400px',
        101: '404px',
        107: '428px',
        109: '436px',
        122.25: '489px',
        124.5: '498px',
        127: '508px',
        131.5: '526px',
        168: '672px',
        164: '656px',
        175.5: '702px',
        209: '836px',
        212.25: '849px',
        222: '888px',
        225.75: '903px',
        228.25: '913px',
        230.5: '922px',
        243.75: '975px',
        235: '940px',
        239.25: '957px',
        249: '996px',
        254: '1016px',
        256.5: '1026px',
        258.75: '1035px',
        281: '1124px',
        300: '1200px',
        413.25: '1653px',
        416.25: '1665px',
        437.5: '1750px',
        458.75: '1835px',
        480: '1920px',
        490: '1960px',
      },
      // adding custom viewport's width
      // use number to refer to the tailwind units, where
      // one  unit is equal to 0.25rem,
      // which translates to 4px by default in common browsers.
      // in other case use string
      width: {
        '66vw': '66vw',
        '69vw': '69vw',
        '72vw': '72vw',
        '74vw': '74vw',
        '74.5vw': '74.5vw',
        '75vw': '75vw',
        '76vw': '76vw',
        '77vw': '77vw',
        '80vw': '80vw',
        '85vw': '85vw',
        '215vw': '215vw',
        '1026vw': '1026vw',
        inherit: 'inherit',
        '55%': '55%',
        '45%': '45%',
      },
      height: {
        '46vh': '46vh',
        '60vh': '60vh',
        fit: 'fit-content', // tailwind v2 doesn't have this value
      },
      // in Tailwind v2 for max-w didn't work spacing property
      // https://v2.tailwindcss.com/docs/customizing-spacing#default-spacing-scale
      // same rules as for spacing: 1 unit = 4 px
      maxWidth: {
        24: '96px',
        34: '136px',
        46.5: '186px',
        52: '208px',
        56: '224px',
        64: '256px',
        72: '288px',
        74: '296px',
        80: '320px',
        87: '348px',
        113.5: '454px',
        120: '480px',
        124.5: '498px',
        127: '508px',
        175.5: '702px',
        249: '996px',
        400: '1600px',
      },
      // same rules as for spacing: 1 unit = 4 px
      minWidth: {
        13: '52px', // for min-w of square buttons
        20.5: '82px', // min-w for 'md' buttons according to the mock up
        29: '116px', // min-w for 'lg' buttons according to the mock up
        56: '224px',
        97.25: '389px',
        107: '428px',
        185.5: '742px',
        209: '836px',
      },
      minHeight: {
        20: '80px',
        100: '400px',
        125: '500px',
        150: '600px',
        185: '740px',
        200: '800px',
        210: '840px',
      },

      maxHeight: {
        65.5: '262px',
      },

      borderRadius: {
        '3px': '3px',
        '10px': '10px',
        '20px': '20px',
      },
      // according Tailwind docs border width is in px
      // https://v2.tailwindcss.com/docs/border-width
      borderWidth: {
        '0.5px': '0.5px',
        '12px': '12px',
      },
      flex: {
        2: '2 2 0%',
      },
      zIndex: {
        100: 100,
      },
      colors: {
        transparent: 'transparent',
        current: 'currentColor',
        'vamos-white': '#FCFCFC',
        'vamos-black': '#020F14',
        'vamos-gray': '#676767',
        'vamos-red': '#FF4C4C',
        'vamos-green1': '#44AC5C',
        'vamos-green2': '#B1DBBB',
        'vamos-green2-opacity-50': 'rgba(177, 219, 187, 0.5)',
        'vamos-green3': '#E2F8D0',
        'vamos-green4': '#317E43',
        'vamos-blue1': '#D6EBF0',
        'vamos-blue2': '#7CB6B0',
        'vamos-blue3': '#52929B',
        'vamos-blue-gray': '#B0C1BF',
        'vamos-light-gray': '#E4E4E4',
        'vamos-v-light-gray': '#F5F5F5',
        'vamos-true-white': '#FFFFFF',
        'vamos-orange': '#FF7614',
        'priority-low': '#44AC5C',
        'priority-medium': '#FFC04C',
        'priority-high': '#FF4C4C',
        'vamos-success': '#44AC5C',
        'vamos-error': '#FF4C4C',
        'vamos-warning': ' #FF7614',
        'vamos-info': '#5EB0E5',
        'vamos-neutral': '#FCFCFC',
        'vamos-error-main': '#D32F2F',
        'vamos-delete': '#FF4C4C',
        'vamos-delete-hover': '#B63232',
      },
      backgroundColor: {
        'modal-background': 'rgba(2, 15, 20, 0.15)',
      },
      backgroundImage: {
        'arrow-down': "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 -960 960 960' width='24'%3e%3cpath d='M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z'/%3e%3c/svg%3e\")",
        'arrow-up': "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 -960 960 960' width='24'%3e%3cpath d='m296-345-56-56 240-240 240 240-56 56-184-184-184 184Z'/%3e%3c/svg%3e\")",
        'radio-default': "url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12Z' stroke='%23595D62'/%3E%3C/svg%3E\")",
        'radio-checked': "url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12Z' fill='%2344AC5C' stroke='%2344AC5C'/%3E%3Cpath d='M4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12Z' stroke='%2344AC5C'/%3E%3C/svg%3E\")",
      },
      backgroundSize: {
        '1.1rem': '1.1rem',

      },
      backgroundPosition: {
        'right-10': 'right 10px center',
      },
      backgroundOpacity: {
        50: '0.5',
      },
      screens: {
        md2: '886px',
        xl2: '1548px',
        '3xl': '1920px',
      },
    },
  },
  variants: {
    extend: {
      backgroundColor: ['even', 'odd'], // using in our Tables component  https://v2.tailwindcss.com/docs/hover-focus-and-other-states#odd-child
    },
  },
  corePlugins: {
    aspectRatio: false,
  },
  // adding plugins for Tailwind v2
  plugins: [
    require('@tailwindcss/line-clamp'),
    require('@tailwindcss/aspect-ratio'),
    // eslint-disable-next-line func-names
    function ({ addUtilities }) { /* this function hide scrollbar. ex. SiteTag component */
      addUtilities({
        /* Hide scrollbar for Chrome, Safari and Opera */
        '.scrollbar-hidden::-webkit-scrollbar': {
          display: 'none',
        },
        '.scrollbar-hidden': {
          'scrollbar-width': 'none', /* Firefox */
          '-ms-overflow-style': 'none', /* IE and Edge */
        },
        /* Hide arrows in number input */
        '.arrow-hide:not(:focus)::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          margin: '0',
        },
        '.arrow-hide:not(:focus)::-webkit-outer-spin-button': {
          '-webkit-appearance': 'none',
          margin: '0',
        },
        '.arrow-hide': {
          '-moz-appearance': 'textfield', // Firefox
        },
      });
    },
  ],
};
